import { put, takeEvery, all, takeLatest } from 'redux-saga/effects';
import { IAction } from '../models/action';
import {  getWallAPI, removePostAPI, updatePostAPI, addPostAPI, getPostAPI,  removeCommentAPI, updateCommentAPI, addCommentAPI, getCommentAPI,  likeHandlerAPI,  getPostsPaginatedAPI, getCommentsPaginatedAPI } from '../services/api';
import {  REQUEST_WALL,  REQUEST_POSTS, REQUEST_POST, ADD_POST, UPDATE_POST, REMOVE_POST, REQUEST_COMMENTS, REQUEST_COMMENT, ADD_COMMENT, UPDATE_COMMENT, REMOVE_COMMENT,  getWallSuccess, getWallError, removePostError, removePostSuccess, updatePostError, updatePostSuccess, addPostError, addPostSuccess, getPostError, getPostSuccess, getPostsError, getPostsSuccess, removeCommentError, removeCommentSuccess, updateCommentError, updateCommentSuccess, addCommentError, addCommentSuccess, getCommentError, getCommentSuccess, getCommentsError, getCommentsSuccess, likeSuccess, likeError, UPDATE_LIKE, USER_SESSION_SET, USER_CREATE, setUserSuccess, setUserSessionSuccess, USER_CHECK_SESSION, getUserSuccess, getUserError, USER_CHECK_SESSION_ERROR, USER_INFO_FORM_SUBMISSION, setUserInfoSubmissionSuccess, setUserInfoSubmissionError, USER_INFO_FORM_CHECK, USER_INFO_FORM_DISMISSED, setUserInfoDismissedError, setUserInfoDismissedSuccess, getPostsMetadataSuccess,  REQUEST_POSTS_METADATA, USER_CONTACT_FORM, setFormValidSuccess} from '../handlers.actions';
import { getUserSession, setCookie, setUser, setUserInfoCookie } from '../helpers/cookies';
import { User } from '../models/user';

const USER_SESSION_VAR = 'user_pancan_wall_session';
const USER_INFO_SESSION_VAR = 'user_submitted_info';
export interface ResponseGenerator{
    config?:any,
    data?:any,
    headers?:any,
    request?:any,
    status?:number,
    statusText?:string,
    success?:boolean
}

function* eventWatcher() {
    /** USER */
    yield takeLatest(USER_CHECK_SESSION, checkForUserSession);
    yield takeLatest(USER_CHECK_SESSION_ERROR, setUserHandler);
    yield takeLatest(USER_CREATE, setUserHandler);
    yield takeLatest(USER_SESSION_SET, setUserSessionHandler);
    yield takeLatest(USER_INFO_FORM_SUBMISSION, setUserInfoSubmission);
    yield takeLatest(USER_INFO_FORM_CHECK, userInfoCheck);
    yield takeLatest(USER_INFO_FORM_DISMISSED, userInfoFormDismissed);
    yield takeEvery(USER_CONTACT_FORM, userContactForm);
    
    /** WALL */
    yield takeEvery(REQUEST_WALL, getWall);

    /** POSTS */
    yield takeEvery(REQUEST_POSTS, getPosts);
    yield takeEvery(REQUEST_POST, getPost);
    yield takeEvery(ADD_POST, addPost);
    yield takeEvery(UPDATE_POST, updatePost);
    yield takeEvery(REMOVE_POST, removePost);
    yield takeLatest(REQUEST_POSTS_METADATA, updatePostsMetadata);

    /** COMMENTS */
    yield takeEvery(REQUEST_COMMENTS, getComments);
    yield takeEvery(REQUEST_COMMENT, getComment);
    yield takeEvery(ADD_COMMENT, addComment);
    yield takeEvery(UPDATE_COMMENT, updateComment);
    yield takeEvery(REMOVE_COMMENT, removeComment);

    /** LIKES */
    yield takeEvery(UPDATE_LIKE, likeHandler);
}

/** USER FUNCTIONS */
function* userContactForm(action:IAction){
    yield put(setFormValidSuccess(action.payload));
}

function* checkForUserSession(){
    const user:User = yield getUserSession(USER_SESSION_VAR);
    const handler = user ? getUserSuccess(user):getUserError();
    yield put(handler);
}

function* setUserHandler(){
    const result:string = yield setUser();
    yield put(setUserSuccess({id:result}));
    yield put({type: USER_SESSION_SET, payload: result}); 
}

function* setUserSessionHandler(action:IAction){
    const result:ResponseGenerator = yield setCookie(USER_SESSION_VAR, action.payload, 20);       
    yield put(setUserSessionSuccess(result));
}

function* userInfoCheck(){
    const user:User = yield getUserSession(USER_INFO_SESSION_VAR);
    const handler = user ? setUserInfoSubmissionSuccess(user):setUserInfoSubmissionError();
    yield put(handler);
}

function* setUserInfoSubmission(action:IAction){
    const user_info:ResponseGenerator = yield setUserInfoCookie('submission', action.payload);
    const handler = user_info? setUserInfoSubmissionSuccess(user_info): setUserInfoSubmissionError();
    yield put(handler);   
}

function* userInfoFormDismissed(){   
    const user_info:ResponseGenerator = yield setUserInfoCookie('dismissed');
    const handler = user_info? setUserInfoDismissedSuccess(user_info): setUserInfoDismissedError();
    yield put(handler);
}

/** WALL */
function* getWall(action: IAction) {
    yield put({type: USER_CHECK_SESSION}); // Check for user session
    yield put({type: USER_INFO_FORM_CHECK}); // Check for user info
    const response: ResponseGenerator = yield getWallAPI(action.payload);
    const handler: any = response.success ? getWallSuccess(response.data): getWallError();
    yield put(handler);  
    if(!response.success) return;

    // Request the featured posts first
    const featuredPostsIds = response.data.featuredPosts.map((item:any) => item.id);
    if(featuredPostsIds.length > 0){
        for(let i = 0; i < featuredPostsIds.length; i++){
            yield put({type: REQUEST_POST, payload: featuredPostsIds[i]});
        }
    }       
    // get the enlighted post here for the ligthbox
    const uri = new URL(window.location.href);
    const enlightedPost = uri.searchParams.get('postId') || false;
    if(enlightedPost) {
        yield put({type: REQUEST_POST, payload: enlightedPost});
        featuredPostsIds.push(enlightedPost);        
    }

    const payload = {tags: response.data.feedTags, v:1, page: 1, per_page: 8, excluded: featuredPostsIds};       
    if(response.data.hasOwnProperty('feedTagsRef') && response.data.feedTagsRef.length > 0) {payload.v = 2; payload.tags = response.data.feedTagsRef.map((tag:any) => tag._id);};  // Check the Version here V2 contains feedTagsRef
    yield put({type: REQUEST_POSTS, payload: payload });
}

/** POSTS */

function* getPosts(action: IAction) {
    const {tags, page, per_page, excluded, v} = action.payload;
    const response: ResponseGenerator = yield getPostsPaginatedAPI(tags, page, per_page, excluded, v); // yield getPostsAPI(action.payload);    
    const handler: any = response.success
        ? getPostsSuccess(response.data.docs)
        : getPostsError();
    yield put(handler);

    if(!response.success) return; // If a successful response request comments if there are some
    yield put({type: REQUEST_POSTS_METADATA, payload: response.data});
    for(let i = 0; i < response.data.docs.length; i++){
        if(response.data.docs[i].totalComments > 0) yield put({type: REQUEST_COMMENTS, payload: {id:response.data.docs[i]._id, page: 1, perpage: 3}});
    }
}

function* updatePostsMetadata(action:IAction){
    yield put(getPostsMetadataSuccess(action.payload));
}

function* getPost(action: IAction) {
    const response: ResponseGenerator = yield getPostAPI(action.payload);    
    const handler: any = response.success
        ? getPostSuccess(response.data)
        : getPostError();    
    yield put(handler);
    if(!response.success) return; // If a successful response request comments if there are some
    if(response.data.totalComments > 0) yield put({type: REQUEST_COMMENTS, payload: {id: response.data._id, page: 1, perpage:3}}); //Request the comments here
}


function* addPost(action: IAction) {
    const response: ResponseGenerator = yield addPostAPI(action.payload);
    const handler: any = response.success
        ? addPostSuccess(response.data)
        : addPostError();
    yield put(handler);
}

function* updatePost(action: IAction) {
    const response: ResponseGenerator = yield updatePostAPI(action.payload);
    const handler: any = response.success
        ? updatePostSuccess(response.data)
        : updatePostError();
    yield put(handler);
}

function* removePost(action: IAction) {
    const response: ResponseGenerator = yield removePostAPI(action.payload);
    const handler: any = response.success
        ? removePostSuccess(response.data)
        : removePostError();
    yield put(handler);
}

/** COMMENTS */
function* getComments(action: IAction) {
    const {id, page, perpage} = action.payload;    
    const response: ResponseGenerator = yield getCommentsPaginatedAPI(id, page, perpage);
    const handler: any = response.success
        ? getCommentsSuccess(response.data.docs)
        : getCommentsError();
    yield put(handler);
}

function* getComment(action: IAction) {
    const response: ResponseGenerator = yield getCommentAPI(action.payload);
    const handler: any = response.success
        ? getCommentSuccess(response.data)
        : getCommentError();
    yield put(handler);
}

function* addComment(action: IAction) {
    const response: ResponseGenerator = yield addCommentAPI(action.payload);
    const handler: any = response.success
        ? addCommentSuccess(response.data)
        : addCommentError();
    yield put(handler);
}

function* updateComment(action: IAction) {
    const response: ResponseGenerator = yield updateCommentAPI(action.payload);
    const handler: any = response.success
        ? updateCommentSuccess(response.data)
        : updateCommentError();
    yield put(handler);
}

function* removeComment(action: IAction) {
    const response: ResponseGenerator = yield removeCommentAPI(action.payload);
    const handler: any = response.success
        ? removeCommentSuccess(response.data)
        : removeCommentError();
    yield put(handler);
}

/** LIKES */
function* likeHandler(action: IAction) {
    const response: ResponseGenerator = yield likeHandlerAPI(action.payload);
    const handler: any = response.success ? likeSuccess(response.data) : likeError();
    yield put(handler);
}

export function* rootSaga() {
    const sagas = [eventWatcher()]; // Load all the sagas
    yield all(sagas);
}